const Rails = require("@rails/ujs")
const Turbo = require("@hotwired/turbo-rails")
const jQuery = require("jquery")

window.Rails = Rails
Rails.start()

window.Turbo = Turbo
window.$ = jQuery
window.jQuery = jQuery

require("../assets/javascripts/bootstrap.min.js")
require("../assets/javascripts/js.cookie.js")
require("../assets/javascripts/jquery.fs.selecter.min.js")
require("../assets/javascripts/jquery.fs.stepper.min.js")
require("../assets/javascripts/google_map.js")
